import React, { useMemo } from 'react';
import { isValid } from 'date-fns';
import generalStyles from './Styles.module.scss';
import './DateRangeColumnFilter.scss';
import ByzzerDateRange from '@/components/ByzzerDateRange';

export const DateRangeColumnFilter = ({ column: { filterValue, setFilter, preFilteredRows, id } }) => {

    const dateRange = useMemo(() => {
        const dates = preFilteredRows
            .map((row) => {
                const date = row.values[id] ? new Date(row.values[id]) : null;
                return date && isValid(date) ? date : null;
            })
            .filter(Boolean);

        if (!dates.length) {
            return { minDate: new Date(), maxDate: new Date() };
        }
        return {
            minDate: new Date(Math.min(...dates.map((date) => date.getTime()))),
            maxDate: new Date(Math.max(...dates.map((date) => date.getTime()))),
        };
    }, [id, preFilteredRows]);

    function onChangeDateRange(startDate, endDate) {
        let fromDate = startDate === null || startDate === undefined ? null : new Date(startDate);
        let toDate = endDate === null || endDate === undefined ? null : new Date(endDate);
        if (fromDate !== filterValue?.from || toDate !== filterValue?.to) {
            setFilter({ from: fromDate, to: toDate });
        }
    }
    return (
        <div className={generalStyles.filterRow}>
            <ByzzerDateRange
                className={'date-range-column-filter'}
                onChange={onChangeDateRange}
                dateSelected={false}
                placeholder="Date Range"
                dateFormat={'MMM d, y'}
                minDate={dateRange.minDate}
                maxDate={dateRange.maxDate}
                defaultStartDate={dateRange.minDate}
                defaultEndDate={dateRange.maxDate}
                isSingleMonthCalendar={true}
            />
        </div>
    );
};
